import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/landing';
export function Hero() {
  return <section className="bg-cream" aria-labelledby="hero-title" data-id="element-68" data-mp="ehtjpxlbn3oc">
      <div className="mx-auto max-w-[1080px] px-5 pb-8 pt-4 md:pb-12 md:pt-8" data-id="element-69" data-mp="9ll8gva8vumg">
        <div className="mx-auto flex max-w-[620px] flex-col items-center text-center" data-id="element-70" data-mp="4mi319qcrmdy">
          <span className="inline-block rounded-full border border-line bg-cream-soft px-2.5 py-[3px] text-[9px] uppercase tracking-[0.14em] text-ink-muted md:text-[10px]" style={{
          height: "26px"
        }} data-id="element-71" data-mp="12a0n3gpgsax9">
            <span className="font-display font-semibold text-ink" data-id="element-72" data-mp="saruar6c52ch">NEROVIX</span>
            <span className="mx-1.5" data-id="element-73" data-mp="nc876ng09kij">·</span>
            <span className="font-bold" data-id="element-74" data-mp="nbexbdlr2ew6">Mega Pack Hombre Magnético</span>
          </span>

          <h1 id="hero-title" className="mt-3 text-[26px] leading-[1.1] sm:text-[36px] lg:text-[44px]" style={{
          fontSize: "28px"
        }} data-id="element-75" data-mp="3d2labedjz91r">
            Perfecciona el arte de la seducción {' '}
            <span className="text-gold" data-id="element-76" data-mp="3j896f9neq5ny">en 7 días</span>
          </h1>

          <p className="mt-2.5 max-w-[390px] text-[12.5px] font-medium leading-snug text-ink-muted md:text-[14px] md:leading-relaxed" style={{
          fontSize: "14px",
          height: "80px"
        }} data-id="element-77" data-mp="3o7lrboupx2nw">
            Entiende por qué una conexión se queda en amistad y mejora tu seguridad, intención y forma de comunicar interés,
sin parecer necesitado.
          </p>

          <div className="mt-3 w-full max-w-[300px]" data-id="element-78" data-mp="30gzteqefgyrm">
            <div className="overflow-hidden rounded-[12px] border border-line bg-cream-soft shadow-[0_14px_32px_-22px_rgba(18,17,15,0.5)]" data-id="element-79" data-mp="358reiletecad">
              <img src={IMAGES.heroMockup} alt="Mega Pack Hombre Magnético — portada del sistema completo" width={700} height={700} className="block aspect-square h-auto w-full" fetchPriority="high" decoding="async" data-id="element-80" data-mp="2qkwiow5ifrt2" />
              
            </div>
          </div>

          <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-line bg-cream-soft px-3.5 py-1.5" data-id="element-81" data-mp="2lkin4dl3iabx">
            <span className="text-[12px] font-medium text-ink-muted line-through" style={{
            fontSize: "14px"
          }} data-id="element-82" data-mp="s2bckbltt7bh">
              US$49
            </span>
            <span className="text-[19px] font-extrabold tracking-[-0.02em] text-ink" style={{
            fontSize: "20px"
          }} data-id="element-83" data-mp="n9i3xcn8leu4">
              US$19
            </span>
            <span className="rounded-full bg-cream-2 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-[0.1em] text-ink-muted" style={{
            fontSize: "12px"
          }} data-id="element-84" data-mp="de6n8os9pxjq">
              Pago único
            </span>
          </div>

          <div className="mt-3 w-full max-w-[330px]" data-id="element-85" data-mp="162ccnou9oapw">
            <CTAButton label="Quiero generar más atracción" data-id="element-86" data-mp="1126o4hjan4c1" />
          </div>

          
        </div>
      <p className="mt-2 text-[10px] font-medium tracking-[0.02em] text-ink-muted" style={{
        fontSize: "12px",
        textAlign: "center"
      }} data-id="element-87" data-mp="x1nwoolbc0ad">
            Acceso inmediato · Sin suscripción · Acceso de por vida
          </p>
      <p className="mx-auto mt-1.5 flex max-w-[330px] items-center justify-center gap-1.5 text-[10px] font-medium text-ink-muted/80" data-id="element-88" data-mp="3hqahwlxb75jg">
            <GlobeIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-89" data-mp="1x784bltydnt2" />
            El precio se mostrará en tu moneda local al momento del pago.
          </p></div>
    </section>;
}